<template>
 <div class='readingBox'>
     <van-nav-bar
      :style="{paddingTop:statusBarHeight+'px'}"
      :title="title"
      left-arrow
      @click-left="
        $router.push({
          path: '/examlistDetails',
          query: { 
              trainItemExamId: $route.query.trainItemExamId,
              trainId:$route.query.businessId, 
              type: $route.query.businessType,
              contentId: $route.query.examId,
              backType: $route.query.backType,
              backPath: $route.query.backPath,
              goodsId: $route.query.goodsId,
              goodsKind: $route.query.goodsKind,
            },
        })
      "
    />
    <div class="readingBox-main">
        <div class="readingBox-title">
            考前必读
        </div>
        <div class="readingBox-content">
            <p class="readingtext" v-if="readingtext" v-html="readingtext">
                {{readingtext}}
            </p>
        </div>
        <div class="readingBox-footer">
            <div v-if="Check">
                <span @click="checkchoose()"><img class="reading" :src="chooseImg" alt /><span class="alreadlyreading">我已阅读</span></span>
            </div>
            <div>
                <van-button :class="Check && radio==true?'footer-btn1':'footer-btn2'" :disabled="!Check" @click="Checkbtn">
                    {{Check ? '开始考试': `倒计时：${maxtime} s`}}
                </van-button>
            </div>
            <div :style="{height:bottomSafeHeight+'px'}"></div>
        </div>
    </div>
    
 </div>
</template>

<script>
export default {
    name: "reading",
    data () {
        return {
            title:'考场纪律',
            stopClickLogin: false,
            maxtime:5,
            Check:false,
            readingtext:'请严格遵守考场纪律，认真答题。一经发现作弊情况将取消考试成绩。预祝各位考生取得好成绩！',
            chooseImg: require("../../../assets/images/exam/notchoose.png"),
            radio: false,
            userPaperParam:{},
            statusBarHeight:0,
            bottomSafeHeight:0
        };
    },
    created(){
        // this.reading()
        this.readingtext = sessionStorage.getItem('readingtext')
        if(localStorage.getItem('type') == 'iOS') {
            this.statusBarHeight = localStorage.getItem("statusBarHeight");
            this.bottomSafeHeight = localStorage.getItem("bottomSafeHeight");
        }
    },
    mounted(){
        if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                console.log("执行")
                window.addEventListener('popstate', this.goPhoneExam,false);
            }
        let timer=setInterval(()=>{
            if(this.maxtime!==1){
                this.maxtime--
            }else{
                clearInterval(timer);
                this.Check=true;
            }
        }, 1000); 
    },
    methods: {
        goPhoneExam(){
            console.log("执行zxc")
    
            this.$router.push({
                path: `/examlistDetails`,
                query:{
                    trainItemExamId: this.$route.query.trainItemExamId,
                    trainId: this.$route.query.businessId,
                    type: this.$route.query.businessType,
                    contentId: this.$route.query.examId,
                    backType: this.$route.query.backType,
                    backPath: this.$route.query.backPath,
                    goodsId: this.$route.query.goodsId,
                    goodsKind: this.$route.query.goodsKind,
                }
            })
        },
        async joinexam(){
            try{
                const params = {
                  businessType:this.$route.query.businessType,
                  examId:this.$route.query.examId,
                  businessId:this.$route.query.businessId,
                  channel:2// 考试来源  0 小程序，1 电脑，2 H5'
                }
                const {data, code} = await this.$api.exam.joinexam({params})
                this.userPaperParam=data
                return code
            }catch(error){
                console.debug(error)
            }
        },
        checkchoose(){
            this.radio=!this.radio
            this.chooseImg =
                this.radio === false
                    ? require("../../../assets/images/exam/notchoose.png")
                    : require("../../../assets/images/exam/choose.png");
        },
        async Checkbtn(){  
            if(!this.radio){
                this.$dialog.confirm({
                    title: '提示',
                    message: '请认真阅读考试纪律，并点击“我已阅读”进行勾选',
                    confirmButtonText:'我已阅读',
                    cancelButtonText:'继续阅读',
                    confirmButtonColor:'#415FF6',
                    cancelButtonColor:'#415FF6',
                    className:'kqbdconfirm',
                    })
                    .then(() => {
                        this.radio=true
                        this.chooseImg =
                            this.radio === false
                                ? require("../../../assets/images/exam/notchoose.png")
                                : require("../../../assets/images/exam/choose.png");
                    })
                    .catch(() => {
                    });
            }else{
                if(this.stopClickLogin){
                   return false
                }
                this.stopClickLogin=true
               setTimeout(()=>{
                  this.stopClickLogin=false
               },5000)
                let code = await this.joinexam();
                if(code === 0) {
                    // 迟到
                    if(this.userPaperParam.beLate){
                        this.$toast('您已超过最迟开考时间');
                    } else {
                        this.$router.push({
                            path:'/examTaking',
                            query:{
                                userPaperId: this.userPaperParam.userPaperId, // 考试id
                                seconds: this.userPaperParam.seconds === null ? 900 : this.userPaperParam.seconds, // 考试允许用时
                                allowCommitDuration: this.userPaperParam.allowCommitDuration === null ? 13 : this.userPaperParam.allowCommitDuration, // 允许交卷时长(单位:分; 0:无, 默认值0)
                                examId:this.$route.query.examId,
                                businessType: this.$route.query.businessType,
                                businessId:this.$route.query.businessId,
                                trainItemExamId:this.$route.query.trainItemExamId,
                                backType: this.$route.query.backType,
                                backPath: this.$route.query.backPath,
                                goodsId: this.$route.query.goodsId,
                                goodsKind: this.$route.query.goodsKind,
                            }
                        })
                        // 考试允许用时
                        sessionStorage.setItem('secondsExam',JSON.stringify(this.userPaperParam.seconds));
                        // 允许交卷时长(单位:分;0:无,默认值0)
                        sessionStorage.setItem('allowCommitDurationExam',JSON.stringify(this.userPaperParam.allowCommitDuration));
                    }
                }
            }
        },
        // reading(){
        //         var examId = this.$route.query.examId
        //         this.$api.exam.reading(examId).then(res=>{
        //             this.readingtext =res.data.notes
                    
        //         })
        // },
    },
    
    destroyed(){
        window.removeEventListener('popstate', this.goPhoneExam,false);
    }
}

</script>
<style lang='stylus'>
    .readingBox-content .readingtext{
        font-size 28px
        color #666666
        line-height 52px
        white-space normal
        word-break break-all
        p{
            img{
                max-width 100% !important;
                height auto !important;
            }
        }
        img{
            max-width 100% !important;
            height auto !important;
        }
    }
    .readingBox
        &-main
            margin 30px
        &-title
            font-size 36px
            font-family PingFangSC-Regular, PingFang SC
            font-weight 400
            color #000000
            line-height 50px
            margin-bottom 28px
        &-content
            margin-bottom 230px
            ul>li
                font-size 28px
                font-family PingFangSC-Medium, PingFang SC
                font-weight 500
                color #666666
                line-height 52px
                margin-bottom 30px
                span
                    color #415FF6
        &-footer
            width 100%
            position fixed
            left 0;
            bottom 0
            text-align center
            padding 32px 30px 30px
            box-sizing border-box
            border-top:1px solid #EBEDF2;
            background-color white
            // box-shadow: 10px 10px 5px red;
            .reading{
                width 48px
                height 48px
                line-height 0.9;
                vertical-align middle;
            }
            .alreadlyreading{
                font-size: 0.64rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
            }
            .van-checkbox
                display inline-flex
            .van-checkbox__icon
                height: 12px;
                .van-icon
                    font-size: .5em;
                    line-height: 0.9;
                    width: 12px;
                    height: 12px;
                    border-radius: 2px;
                    border: 1px solid #C7C7C7;
            .van-checkbox__label
                    font-size: 0.64rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
            .van-button
                width 100%
                height: 44px;
                background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
                border-radius: 25px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 22px;
                margin-top 7px
            .van-button--info{
                background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
                border: none
            }
            .footer-btn1
                opacity: 1;
            .footer-btn2
                opacity: 0.3;
    .kqbdconfirm
        .van-dialog__footer
            width 100%

</style>